export default __webpack_public_path__ + "static/media/ring_of_boreas.57cb2e66.png";